import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import Picture from '@cotyorg/ccx-atoms/Picture';
import { HeroFullCombined } from '@cotyorg/ccx-organism-hero';
import { VideoPlayer } from '@cotyorg/ccx-organism-video';
import StandardLayout from '../../templates/StandardLayout';
import { isLargeBreakpoint } from '../../utils';

const RimmelGirlsPage = ({ images, numberOfHeroes, currentBreakpoint }) => (
  <StandardLayout>
    <div className="rimmel-girls">
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16">
            <div className="rimmel-girls__banner">
              <Picture
                alt={R.path(['banner', 0, 'imageAlt'], images)}
                src={R.path(['banner', 0, 'imageSrc'], images)}
                srcset={R.path(['banner', 0, 'imageSrcSet'], images)}
              />
            </div>
          </div>
        </div>
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16 visible">
            <div className="rimmel-girls__contest">
              <HeroFullCombined
                heroStoreDataKey="contestHero"
                layout="vertical"
                verticalMediumContentColumns={12}
                verticalLargeContentColumns={12}
                verticalExtraLargeContentColumns={9}
              />
            </div>
          </div>
        </div>
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16 visible">
            <div className="rimmel-girls__heroSection">
              {[...Array(numberOfHeroes)].map((item, index) => {
                const isContentFirst =
                  index % 2 !== 0 && isLargeBreakpoint({ currentBreakpoint });

                return (
                  <HeroFullCombined
                    heroStoreDataKey={`hero${index + 1}`}
                    isContentFirst={isContentFirst}
                    isUnderlined={false}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16">
            <div className="rimmel-girls__video">
              <VideoPlayer
                videosStoreDataKey="rimmelGirlsVideo"
                showControls={false}
                config={{
                  youtube: {
                    playerVars: {
                      controls: 1,
                    },
                    embedOptions: {
                      host: 'https://www.youtube-nocookie.com',
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

RimmelGirlsPage.propTypes = {
  images: PropTypes.objectOf(PropTypes.array),
  numberOfHeroes: PropTypes.number,
  currentBreakpoint: PropTypes.string,
};

export default connect(({ content, breakpoints }) => ({
  currentBreakpoint: R.prop('current', breakpoints),
  images: R.prop('images', content),
  numberOfHeroes: R.path(['custom', 'numberOfHeroes'], content),
  videos: R.prop('videos', content),
}))(RimmelGirlsPage);
